<template>
  <g id="ic_record_voice_over_24px" transform="translate(-1 -5)">
    <circle id="Ellipse_3" data-name="Ellipse 3" cx="9.313" cy="9.313" r="9.313" transform="translate(10.313 5)"/>
    <path id="Path_3" data-name="Path 3" d="M19.859,15C13.565,15,1,18.159,1,24.429v4.715H38.718V24.429C38.718,18.159,26.153,15,19.859,15Z" transform="translate(0 13.574)"/>
  </g>
</template>
